import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import {
  Case,
  Default,
  Switch,
} from "../components/common/ConditionalRendering";
import useMobileView from "../hooks/useMobileView";
import DesktopLayout from "../layout/DashboardLayout";
import MobileLayout from "../layout/MobileLayout";
import FeatureEnabledRoute from "../Routing/FeatureEnabledRoute";

const SupervisionRoute = () => {
  const user = useSelector(state => state.auth.user);
  const supervisionRoles = useSelector(state => state.supervision.roles);

  const isMobileView = useMobileView();

  const Layout = isMobileView ? MobileLayout : DesktopLayout;

  return (
    <Switch>
      <Case condition={!user}>
        <Navigate to="/login" replace />
      </Case>
      <Case condition={!supervisionRoles.length}>
        <Navigate to="/dashboard" replace />
      </Case>
      <Default>
        <FeatureEnabledRoute>
          <Layout>
            <Outlet />
          </Layout>
        </FeatureEnabledRoute>
      </Default>
    </Switch>
  );
};

export default SupervisionRoute;
